import {
  getObjectByIdFromArray,
  IObjectById
} from '../../../../../../contrib/Utils/getObjectByIdFromArray';
import { IEventEnrollment } from '../../../../../../store/admin/eventEnrollments/store';
import { IStateDispatchActions } from '../TeeSheetCreator.context';

export type ISetEnrollments = (enrollments: IEventEnrollment[]) => void;

export const setEnrollments: IStateDispatchActions<ISetEnrollments> = (
  _,
  dispatch
) => async enrollments => {
  const value: IObjectById<IEventEnrollment> = getObjectByIdFromArray<IEventEnrollment>(
    enrollments
  );

  dispatch({
    type: 'setEnrollments',
    value
  });
};
